import angular from "angular";

angular
    .module('api-common')
    .factory('ApiInterceptorService', ApiInterceptorService)
    .config(configureInterceptor);

ApiInterceptorService.$inject = ['$q', '$injector', 'SENTINEL_API_HOST_CONSTANTS', 'ApiToken'];

export function ApiInterceptorService($q, $injector, HOST, ApiToken) {
    var interceptor = {
        request: requestInterceptor,
        responseError: responseErrorInterceptor
    };
    return interceptor;

    function requestInterceptor(config) {
        if (!_.startsWith(config.url, HOST.URL + '/rest/')) {
            return config;
        }
        if (_.startsWith(config.url, HOST.URL + '/rest/1/devicerecovery/getDeviceRecoveryByToken')) {
            return config;
        }
        if (_.startsWith(config.url, HOST.URL + '/rest/1/devicerecovery/UpdateDeviceRecovery')) {
            return config;
        }

        if (_.startsWith(config.url, HOST.VISION_URL)) {
            return config;
        }

        var apiToken = ApiToken.get();
        config.__usesSentinelWebAuth = true;

        return angular.extend(config, {
            headers: angular.extend({}, config.headers, {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': apiToken.type + ' ' + apiToken.token
            })
        });
    }

    function responseErrorInterceptor(rejection) {
        const config = rejection.config || {};
        const isRecoverableRequest =
            rejection.status === 401 &&
            config.__usesSentinelWebAuth &&
            _.startsWith(config.url, HOST.URL + '/rest/');

        if (!isRecoverableRequest) {
            return $q.reject(rejection);
        }

        const session = $injector.get('SentinelUiSession');
        if (config.__webAuthRetried) {
            const activeToken = ApiToken.get();
            const activeAuthorization = activeToken
                ? activeToken.type + ' ' + activeToken.token
                : undefined;
            const failedAuthorization = config.headers && config.headers.Authorization;
            if (failedAuthorization === activeAuthorization) {
                session.expireSession();
            }
            return $q.reject(rejection);
        }

        return session.refreshAccessToken()
            .then(function (tokenResponse) {
                const retryConfig = angular.copy(config);
                retryConfig.__webAuthRetried = true;
                retryConfig.headers = angular.extend({}, retryConfig.headers, {
                    'Authorization': tokenResponse.token_type + ' ' + tokenResponse.access_token
                });
                return $injector.get('$http')(retryConfig);
            }, function (refreshError) {
                session.handleRefreshFailure(refreshError);
                return $q.reject(refreshError);
            });
    }
}

configureInterceptor.$inject = ['$httpProvider'];

function configureInterceptor($httpProvider) {
    $httpProvider.interceptors.push('ApiInterceptorService');
}
